/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

/**
 * The main TodoMVC app module.
 *
 * @type {angular.Module}
 */
module part {
  'use strict';

  var part = angular.module('part', ['navigation', 'shoppinglist'])
    .controller('PartCtrl', PartCtrl)
    .controller('PartDetailCtrl', PartDetailCtrl)
    .controller('PartOrderDetailCtrl', PartOrderDetailCtrl)
    .filter('partsByGroupAndCat', partsByGroupAndCatFilter)
    .directive('partBox',PartBoxDirective)
    .directive('productBox',ProductBoxDirective)
    .directive('partDetail', PartDetailDirective)
    .service('partService', PartService);  
}